import constate from "constate";
import { useState, useLayoutEffect } from "react";
import Cookies from "universal-cookie";
const globalCookies = new Cookies();
const setGlobalCookie = globalCookies.set.bind(globalCookies);
const removeGlobalCookie = globalCookies.remove.bind(globalCookies);
function useCookies() {
  const [cookies, setCookies] = useState(globalCookies.getAll());
  useLayoutEffect(() => {
    function onChange() {
      const newCookies = globalCookies.getAll();
      setCookies(newCookies);
    }
    globalCookies.addChangeListener(onChange);
    return () => {
      globalCookies.removeChangeListener(onChange);
    };
  }, []);
  return {
    setCookie: setGlobalCookie,
    removeCookie: removeGlobalCookie,
    cookies
  };
}
const dest = constate(useCookies);
const CookiesProvider = dest[0];
const useCookiesContext = dest[1];
export {
  CookiesProvider as C,
  useCookiesContext as u
};
//# sourceMappingURL=context-BLGMb4ty.js.map
